const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/idea-management/ideas/completed/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
const searchSchema = z.object({
  ideaId: z.number().optional()
});
export const Route = createFileRoute('/(app)/org/$org/idea-management/ideas/completed/')({
  validateSearch: search => searchSchema.parse(search),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    topNav: {}
  }
});